import { ForwardedRef, forwardRef } from 'react'

import './styles.scss'
import { IInputProps } from './types'

export const Input = forwardRef(function Input(
  {
    leftIcon,
    rightIcon,
    placeholder,
    className,
    wrapperClassName,
    onChange,
    type = 'text',
    error,
    hasError,
    disabled,
    label,
    fullscreen = false,
    name,
    description,
    ...props
  }: IInputProps,
  inputRef: ForwardedRef<HTMLInputElement>
) {
  const LeftIcon = leftIcon?.icon
  const RightIcon = rightIcon?.icon

  const getContainerClasses = () => {
    const classes = []

    if (error || hasError) classes.push('inputError')

    if (disabled) classes.push('disabled')

    if (className) classes.push(className)

    return classes.join(' ')
  }

  return (
    <div
      style={{
        width: props.width ? props.width : fullscreen ? '100%' : 200,
        height: props.height ?? 48,
      }}
      className={`inputContainer ${wrapperClassName ? wrapperClassName : ''}`}
    >
      {label && (
        <label className="label" htmlFor={name}>
          {label}
        </label>
      )}

      <div className={`iconContainer ${getContainerClasses()}`}>
        {LeftIcon && (
          <LeftIcon
            className={`leftIcon ${leftIcon?.onClick ? 'clickable' : ''}`}
            onClick={leftIcon?.onClick}
          />
        )}

        <input
          ref={inputRef}
          id={name}
          className="input"
          placeholder={placeholder ? placeholder : ''}
          onChange={onChange}
          disabled={disabled ?? false}
          type={type}
          {...props}
        />

        {description && description}
        {!description && RightIcon && (
          <RightIcon
            className={`rightIcon ${rightIcon?.onClick ? 'clickable' : ''}`}
            onClick={rightIcon?.onClick}
          />
        )}
      </div>

      {error && !disabled && <span className="error">{error}</span>}
    </div>
  )
})
